import type { PreviewTabSignal } from "./use-widget-env";
import type { WidgetTab } from "./widget-config";

/** Message the iframe loader posts for `Wexio('open' | 'close' | 'navigate')`. */
export const HOST_CONTROL_MESSAGE = "wexio:host-control:v1";

export type HostControl =
  | { command: "open" }
  | { command: "close" }
  | { command: "navigate"; signal: PreviewTabSignal };

const TABS: readonly WidgetTab[] = ["home", "messages", "help", "news", "profile"];

function parseArticle(raw: unknown): PreviewTabSignal["article"] {
  if (!raw || typeof raw !== "object") return undefined;
  const a = raw as { kind?: unknown; slug?: unknown; id?: unknown };
  if (a.kind === "help" && typeof a.slug === "string" && a.slug)
    return { kind: "help", slug: a.slug };
  if (a.kind === "news" && typeof a.id === "string" && a.id) return { kind: "news", id: a.id };
  return undefined;
}

/** Validate an untrusted `message` payload from the loader. `null` when it is not a well-formed host command. */
export function parseHostControl(data: unknown): HostControl | null {
  if (!data || typeof data !== "object") return null;
  const d = data as { type?: unknown; command?: unknown; tab?: unknown; nonce?: unknown };
  if (d.type !== HOST_CONTROL_MESSAGE) return null;
  if (d.command === "open" || d.command === "close") return { command: d.command };
  if (d.command !== "navigate") return null;
  if (!TABS.includes(d.tab as WidgetTab)) return null;
  if (typeof d.nonce !== "number" || !Number.isFinite(d.nonce)) return null;
  const article = parseArticle((data as { article?: unknown }).article);
  return {
    command: "navigate",
    signal: { tab: d.tab as WidgetTab, nonce: d.nonce, ...(article ? { article } : {}) },
  };
}
